import Input from "../Input/Input";
import styles from "./IncrementInput.module.scss";
import arrowBottom from "../../../assets/icons/arrowBottom.svg";
import arrowTop from "../../../assets/icons/arrowTop.svg";
import {useEffect, useState} from "react";

const IncrementInput = ({
  placeholder,
  value,
  required,
  disabled,
  handleInput,
  error,
  name,
  noMargin,
  min = 0,
  max,
  autoFocus,
  step = 1,
}) => {
  const [inputValue, setInputValue] = useState(value);

  const parseInputValue = (value) => ["-", ""].includes(value) ? value : (isNaN(value) ? "" : adjustValueToRange(value));
  const adjustValueToRange = (value) => {
    // Don't use Min.max() & Math.mix() because it casts floats like 1.0 to integers
    const countedMax = max !== undefined && max < value ? max : value;

    return countedMax >= min ? countedMax : min;
  };
  const countValueChangedBy = (change) => adjustValueToRange((isNaN(inputValue) || inputValue === "" ? 0 : + inputValue) + change).toFixed(-Math.log10(step));

  useEffect(() => {
    if (!isNaN(inputValue) && inputValue !== "") {
      handleInput({ target: { name: name, value: adjustValueToRange(inputValue) } });
    }
  }, [inputValue]);

  return (
    <div className={styles.inputWrapper}>
      <Input
        variant="text"
        name={name}
        value={inputValue}
        error={error}
        handleInput={(e) => setInputValue(parseInputValue(e.target.value))}
        placeholder={placeholder}
        required={required}
        disabled={disabled}
        noMargin={noMargin}
        onWheel={(e) => e.target.blur()}
        autoFocus={autoFocus}
        step={step}
      />
      <span className={styles.arrowWrapper}>
        <img onClick={() => setInputValue(countValueChangedBy(step))} src={arrowTop} alt="" />
        <img onClick={() => setInputValue(countValueChangedBy(-step))} src={arrowBottom} alt="" />
      </span>
    </div>
  );
};

export default IncrementInput;
